// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VmfxXHpk .NYuRe9gx{background:none;margin:0 calc(var(--p-x)*-1);padding:0}.VmfxXHpk .NYuRe9gx .index-footer-contacts{flex-direction:column}.VmfxXHpk .NYuRe9gx .index-footer-contacts>*+*{margin-left:0;margin-top:2.5rem}.VmfxXHpk .NYuRe9gx .index-footer-end{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "VmfxXHpk",
	"footer": "NYuRe9gx"
};
module.exports = ___CSS_LOADER_EXPORT___;
